import IframeActivity from "./IframeActivity";

export default function MrPresident() {
    return (
        <IframeActivity
            src="/activities/mr-president/index.html"
            title="Mr. President"
        />
    );
}